var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Type, Transform, Expose } from 'class-transformer';
export class EventDetailsModel {
    id;
    triggeredAt;
    description;
    severity;
    title;
    alertDefinitionId;
    mitreTags = [];
}
__decorate([
    Expose({ name: 'alertEventId' }),
    __metadata("design:type", String)
], EventDetailsModel.prototype, "id", void 0);
__decorate([
    Type(() => Date),
    Transform(value => value * 1000, { toClassOnly: true }),
    __metadata("design:type", Date)
], EventDetailsModel.prototype, "triggeredAt", void 0);
__decorate([
    Exclude({ toPlainOnly: true }),
    __metadata("design:type", String)
], EventDetailsModel.prototype, "title", void 0);
__decorate([
    Exclude({ toPlainOnly: true }),
    __metadata("design:type", Number)
], EventDetailsModel.prototype, "alertDefinitionId", void 0);
__decorate([
    Exclude(),
    __metadata("design:type", Array)
], EventDetailsModel.prototype, "mitreTags", void 0);
//# sourceMappingURL=event-details.js.map